<form class="card mt-2">
  <div class="card-body">
    <h2 class="mb-3">My Referrals</h2>
    <div class="mb-3">
      <div class="row">
        <div class="col-xl-6 col-12">
          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h5>Show Rejected Referrals:</h5>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="rejectedReferralsFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <div class="row mb-1">
            <div class="col-4 d-flex align-items-center">
              <h5>Show Archived Referrals:</h5>
            </div>
            <div class="col-8 ">
              <p-selectButton styleClass="w-100 ml-2" [options]="yesNoAllOptions" [(ngModel)]="archivedReferralsFilter" (ngModelChange)="reloadFilter(this.filter)" [ngModelOptions]="{standalone: true}"></p-selectButton>
            </div>
          </div>
        </div>

      </div>


    </div>

    <i [hidden]="!loadingList" class="material-icons rotate text-muted">loop</i>
    <p-table [value]="list?.result" [responsive]="true" [paginator]="true" [rows]="20"
             [totalRecords]="list?.totalRecords" [lazy]="true" (onLazyLoad)="reloadFilter($event)">
      <ng-template pTemplate="header">
        <tr>
          <th width="100px"></th>
          <th [pSortableColumn]="'NewHire'">New Hire <p-sortIcon [field]="'NewHire'"></p-sortIcon></th>
          <th [pSortableColumn]="'TrainingStartDate'">Training Start Date (Days after hire) <p-sortIcon [field]="'TrainingStartDate'"></p-sortIcon></th>
          <th [pSortableColumn]="'NextBonusDate'">Next Bonus Date<p-sortIcon [field]="'NextBonusDate'"></p-sortIcon></th>
          <th >Referral Bonus</th>
          <th *ngIf="archivedReferralsFilter != false" [pSortableColumn]="'ArchivedDate'">Archived Date<p-sortIcon [field]="'ArchivedDate'"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-referral>
        <tr>
          <td>
            <div style="display: inline-flex;">
              <span class="pointer mr-2" style="font-size: x-large; color: red;" *ngIf="hasFormToSign(referral)" (click)="fillForm(referral)"><i title="Fill form" class="fab fa-wpforms"></i></span>
              <span class="pointer mr-2" style="font-size: x-large;" *ngIf="hasSignedForm(referral)" (click)="viewForm(referral)"><i title="View form" class="fab fa-wpforms"></i></span>
              <span class="pointer mr-2" style="font-size: x-large;" *ngIf="showCreateFormButton(referral)" (click)="createReferralForm(referral)"><i title="Create form" class="fal fa-file-plus"></i></span>
            </div>
          </td>
          <td>
            <span class="ui-column-title">NewHire</span>
            {{referral.newHireLastName}}, {{referral.newHireFirstName}} <span style="font-style:italic; color: red; font-size: 0.8rem;">{{getNewHireDetailsString(referral)}}</span>
          </td>
          <td>
            <span class="ui-column-title">Training Start Date</span>
            {{(referral.newHireTrainingStartDate !== null) ? (referral.newHireTrainingStartDate | date: 'MM/dd/yyyy') : ""}} <span style="font-style:italic; font-size: 0.8rem;" title="Days after hire">{{getNewHireDaysAfterHire(referral)}}</span>
          </td>
          <td>
            <span class="ui-column-title">Next Bonus Date</span>
            {{(referral.nextBonusDate !== null) ? (referral.nextBonusDate | date: 'MM/dd/yyyy') : ""}}
          </td>
          <td >
            <span class="ui-column-title">Referral Bonus</span>
            <div *ngFor="let pb of referral.payrollBonuses">
              {{pb.payrollEndDate | date: 'MM/dd/yyyy'}}
            </div>
            <div *ngIf="referral.rejectionDate" title="{{referral.rejectionDate | date: 'MM/dd/yyyy @ h:mm:ss a'}}">
              <span style="cursor: default; font-weight: bold; font-style:italic;">
                Rejected
              </span><br />
              <span style="cursor: default; font-size: 0.95em;">
                {{referral.rejectionReason}}
              </span>
            </div>
          </td>
          <td *ngIf="archivedReferralsFilter != false">
            <span class="ui-column-title">Archived Date</span>
            {{(referral.archivedDate !== null) ? (referral.archivedDate | date: 'MM/dd/yyyy') : ""}}
            <br />
            <span style="cursor: default; font-size: 0.95em;">
              {{referral.archivedReason}}
            </span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</form>

<app-edit-referral></app-edit-referral>
